import {BankAccount,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";


export const Profile = ({record}: { record: BankAccount }) => {
    console.debug(record)

    const properties = [
        {
            label: 'ID',
            value: record.id as string,
            span: 6,
        }, {
            label: 'Customer',
            value: record.customerId as string,
            span: 6,
        }, {
            label: 'Number',
            value: record.accountNumber,
            span: 6,
        }, {
            label: 'Country',
            value: record.country,
            span: 6,
        }, {
            label: 'Currency',
            value: record.currency,
            span: 6,
        }, {
            label: 'Account Holder',
            value: record.accountHolderName,
            span: 6,
        }, {
            label: 'Account Holder Type',
            value: record.accountHolderType,
            span: 6,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 3,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 3,
        }];


    return (
        <PlatformPropertyCard properties={properties}/>
    );


};
